namespace GeniuzPOS.SalePromoCamp {
    export enum PromoTimeFg {
        alltimedy = 0,
        chtime = 1
    }
    Serenity.Decorators.registerEnumType(PromoTimeFg, 'GeniuzPOS.SalePromoCamp.PromoTimeFg');
}
